import { useSyncExternalStore } from 'react';
import { getLocale, subscribeLocale, t } from './index';

export function useLocale() {
  return useSyncExternalStore(subscribeLocale, getLocale, getLocale);
}

export default function useT() {
  const locale = useLocale();
  return (key, vars) => t(key, vars, locale);
}
